import pageSelect from "./page-select/index.js";
import SkuForm from "./SkuForm/index.js";
const components = [pageSelect, SkuForm];

const install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  pageSelect,
};
